import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const Welcome = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      className="w-full h-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
    >
      <div className="flex flex-col items-center h-auto px-6 py-16 md:px-16">
        <h1 className="max-w-2xl text-center text-3xl !leading-tight text-gray-600 md:text-5xl">
          Start your Personalized Portfolio Journey
        </h1>
        <h2 className="max-w-md mt-6 text-base font-normal text-center text-gray-500 md:mt-8">
          You’re on your way to taking the work out of retirement. Here’s what
          to expect:
        </h2>

        <div className="grid grid-cols-1 mt-8 list-none sm:gap-y-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col px-6 py-8 border-gray-300 sm:py-6 sm:border-r md:px-8">
            <span className="flex h-[32px] w-[32px] items-center justify-center self-start rounded-full bg-as-teal-0 text-lg font-bold text-gray-800">
              1
            </span>
            <span className="mt-5 text-lg font-bold leading-tight text-gray-800">
              Verify your <br />
              account
            </span>
            {/* <span className="mt-1 text-xs font-bold leading-normal text-gray-500">1 MIN</span> */}
            <span className="mt-4 text-sm leading-normal text-gray-500">
              We use bank-level, 256-bit encryption to keep your information
              safe.
            </span>
          </div>
          <div className="flex flex-col px-6 py-8 border-gray-300 sm:py-6 lg:border-r max-sm:border-t md:px-8">
            <span className="flex h-[32px] w-[32px] items-center justify-center self-start rounded-full bg-as-orange-0 text-lg font-bold text-gray-800">
              2
            </span>
            <span className="mt-5 text-lg font-bold leading-tight text-gray-800">
              Choose your <br />
              path
            </span>
            {/* <span className="mt-1 text-xs font-bold leading-normal text-gray-500">5 MIN - 8 MIN</span> */}
            <span className="mt-4 text-sm leading-normal text-gray-500">
              Pick the recommendation track that is most appealing to you.
            </span>
          </div>
          <div className="flex flex-col px-6 py-8 border-gray-300 sm:py-6 sm:border-r max-sm:border-t md:px-8">
            <span className="flex h-[32px] w-[32px] items-center justify-center self-start rounded-full bg-as-blue-0 text-lg font-bold text-gray-800">
              3
            </span>
            <span className="mt-5 text-lg font-bold leading-tight text-gray-800">
              Complete an assessment
            </span>
            {/* <span className="mt-1 text-xs font-bold leading-normal text-gray-500">3 MIN - 5 MIN</span> */}
            <span className="mt-4 text-sm leading-normal text-gray-500">
              Help us understand your needs through a set of questions.
            </span>
          </div>
          <div className="flex flex-col px-6 py-8 border-gray-300 sm:py-6 max-sm:border-t md:px-8">
            <span className="flex h-[32px] w-[32px] items-center justify-center self-start rounded-full bg-as-green-0 text-lg font-bold text-gray-800">
              4
            </span>
            <span className="mt-5 text-lg font-bold leading-tight text-gray-800">
              Receive your portfolio
            </span>
            {/* <span className="mt-1 text-xs font-bold leading-normal text-gray-500">1 MIN</span> */}
            <span className="mt-4 text-sm leading-normal text-gray-500">
              We’ll get to work and put you on course to retirement.
            </span>
          </div>
        </div>

        <button
          onClick={() => navigate("/login")}
          className="mt-8 btn btn--primary md:mt-12"
        >
          Continue
        </button>
      </div>
    </motion.div>
  );
};

export default Welcome;
